import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df4d1098"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overview" }
const _hoisted_2 = { class: "name-group grid" }
const _hoisted_3 = { class: "value-group grid" }

import { computed } from 'vue';
import { getOverviewData, _testOverviewData } from './index';


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-overview-6',
  setup(__props) {

const showData = computed(() => {
  const tableData = getOverviewData(_testOverviewData, false, false, false);
  return tableData.reduce(
    (pre, cur) => {
      const last = pre.slice(-1)[0];
      if (Array.isArray(last) && last?.length < 3) {
        pre.slice(-1)[0]?.push(cur);
      } else {
        pre.push([cur]);
      }
      return pre;
    },
    [[]] as Array<typeof tableData>
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showData.value, (row, rowIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row",
        key: rowIndex
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "name",
              key: index
            }, _toDisplayString(item.name), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "value",
              key: index
            }, _toDisplayString(item.value), 1))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}
}

})